import { createVariantSelectorTree } from '../utils/create-variant-facet-tree.js';
import { getCommercialCategories } from '../utils/get-commercial-categories.js';
import '@grandvisionhq/utils';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../types/product.js';

const mapServerToProductBase = (serverProduct, variants, facetConfigList)=>{
    var ref, ref1, ref2;
    const variantFacetTree = (facetConfigList === null || facetConfigList === void 0 ? void 0 : facetConfigList.length) ? createVariantSelectorTree(variants, facetConfigList) : [];
    const commercialCategories = getCommercialCategories(serverProduct.commercialCategories);
    var ref3, _ratingsSummary, ref4, _supplier;
    return {
        id: serverProduct.id,
        name: serverProduct.name,
        brandName: serverProduct.brand,
        masterSku: serverProduct.variants[0].sku,
        variantFacetTree,
        commercialCategories,
        analyticsData: {
            category: (ref3 = (ref = serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.categories[0]) === null || ref === void 0 ? void 0 : ref.name) !== null && ref3 !== void 0 ? ref3 : undefined,
            ratingsSummary: (_ratingsSummary = serverProduct.ratingsSummary) !== null && _ratingsSummary !== void 0 ? _ratingsSummary : undefined,
            vatRate: (ref4 = (ref1 = serverProduct.taxCategory) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.rate) === null || ref2 === void 0 ? void 0 : ref2.amount) !== null && ref4 !== void 0 ? ref4 : undefined
        },
        supplier: (_supplier = serverProduct.supplier) !== null && _supplier !== void 0 ? _supplier : undefined,
        //booleans
        isReviewEnabled: !!serverProduct.isReviewEnabled,
        isPublished: serverProduct.isPublished
    };
};

export { mapServerToProductBase };
//# sourceMappingURL=map-server-to-product-base.js.map
